import { Typography } from 'antd';
import React from 'react';

const Put = () => {
  return (
    <Typography.Text type='secondary' style={{ marginRight: '8px' }}>
      PUT
    </Typography.Text>
  );
};

export default Put;
